import React from "react";
import { ISelectProps, SelectInput } from "~/components/Controls/Select";
import { ID } from "~/lib/model";
import { sortByString } from "~/lib/sort";
import { TableSortDirection } from "~/components/Table";
import { FormField, hasError, IFieldProps, onChangeField } from "~/components/Form";
import { Intent } from "~/lib/intent";
import { useAgencyAccountManagersQuery } from "~/modules/Dictionary/queries";

type IAccountManagerAgencyProps = Omit<ISelectProps<ID>, "items">;

export const SelectAccountManagerAgency = ({ disabled, ...props }: IAccountManagerAgencyProps) => {
  const { data: resource = [], isPending } = useAgencyAccountManagersQuery();
  return (
    <SelectInput
      {...props}
      disabled={disabled || isPending}
      rightIcon={isPending && !disabled && <i className="fa fa-spinner fa-spin" />}
      items={sortByString(
        resource.map((manager) => ({
          label: manager.name,
          value: manager.id,
        })),
        "label",
        TableSortDirection.ASC
      )}
    />
  );
};

export const SelectAccountManagerAgencyField = (props: IFieldProps<IAccountManagerAgencyProps>) => (
  <FormField {...props}>
    <SelectAccountManagerAgency
      {...props.options}
      intent={hasError(props) && Intent.DANGER}
      value={props.field.value}
      onChange={(value) => onChangeField(props, value)}
    />
  </FormField>
);
